export default "__VITE_ASSET__976b090c__"